module.exports = __webpack_public_path__ + "img/bg3.8e7d4999.jpg";